// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-mention-list-max-height: 300px;
}

.ck.ck-mentions {
	max-height: var(--ck-mention-list-max-height);

	overflow-y: auto;

	/* Prevent unnecessary horizontal scrollbar in Safari
	https://github.com/ckeditor/ckeditor5-mention/issues/41 */
	overflow-x: hidden;

	overscroll-behavior: contain;
}

/* Prevent unnecessary vertical scrollbar in Safari
https://github.com/ckeditor/ckeditor5-mention/issues/41 */
.ck.ck-mentions > .ck-list__item {
	overflow: hidden;
	flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/ckeditor5-mention/theme/mentionui.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;CACC,mCAAmC;AACpC;;AAEA;CACC,6CAA6C;;CAE7C,gBAAgB;;CAEhB;0DACyD;CACzD,kBAAkB;;CAElB,4BAA4B;AAC7B;;AAEA;yDACyD;AACzD;CACC,gBAAgB;CAChB,cAAc;AACf","sourcesContent":["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-mention-list-max-height: 300px;\n}\n\n.ck.ck-mentions {\n\tmax-height: var(--ck-mention-list-max-height);\n\n\toverflow-y: auto;\n\n\t/* Prevent unnecessary horizontal scrollbar in Safari\n\thttps://github.com/ckeditor/ckeditor5-mention/issues/41 */\n\toverflow-x: hidden;\n\n\toverscroll-behavior: contain;\n}\n\n/* Prevent unnecessary vertical scrollbar in Safari\nhttps://github.com/ckeditor/ckeditor5-mention/issues/41 */\n.ck.ck-mentions > .ck-list__item {\n\toverflow: hidden;\n\tflex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
